import React from 'react'

// svg
import globle from '../Assets/globe.svg'
import flash from '../Assets/flash.svg'
import shield from '../Assets/shield.svg'

interface ReasonsType {
  icon: string;
  title: string;
  description: string;
}

const WhyChoose:React.FC = () => {

  const reasonsOne: ReasonsType[] = [
    {
      icon: globle,
      title: 'Tailored Notes',
      description: 'Comprehensive and organized notes aligned with the UTME syllabus.'
    },
    {
      icon: shield,
      title: 'Practice Quizzes',
      description: 'Practice Quizzes: "Test your knowledge and unlock modules as you progress.'
    },
    {
      icon: flash,
      title: 'AI chat Assistance',
      description: 'Get instant help with any topic or question with A.I assistant in all note modules.'
    }
  ]

  const reasonsTwo: ReasonsType[] = [
    {
      icon: globle,
      title: 'Progress Tracking',
      description: 'Track your improvement with state of the art analytic insights and focus on weak areas.'
    },
    {
      icon: shield,
      title: 'National Competition',
      description: 'Compete in real-time challenges for prizes and leaderboard recognition.'
    }
  ]

  return (
    <section className='py-16 md:py-20 relative'>
      <div className='container'>
        <h2 className='text-[30px] md:text-[36px] text-center font-bold mb-12'>Why Choose Examcompass?</h2>
        <div className='lg:w-[73%] mx-auto flex flex-col md:flex-row items-center justify-between gap-8 md:gap-5 mb-8 md:mb-4 lg:mb-10'>
          {reasonsOne?.map( item => (
            <div key={item.title} className='w-[275px] h-[260px] lg:w-[265px] lg:h-[275px] py-[32px] px-[48px] md:py-[28px] md:px-[32px] lg:pt-[20px] lg:px-[48px] flex flex-col items-center shadow-customShadow'>
              <img src={item.icon} alt={item.title} className='mb-4' />
              <div className=''>
                <p className='text-darkText text-[22px] md:text-[20px] text-center font-semibold mb-3'>{item.title}</p>
                <p className='text-textColor text-center text-[14px]'>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className='lg:w-[73%] mx-auto flex flex-col md:flex-row justify-between items-center gap-8'>
          {reasonsTwo?.map( item => (
            <div key={item.title} className='w-[275px] h-[260px] lg:w-[265px] lg:h-[275px] py-[32px] px-[48px] md:py-[28px] md:px-[32px] lg:pt-[20px] lg:px-[48px] flex flex-col items-center shadow-customShadow'>
              <img src={item.icon} alt={item.title} className='mb-3' />
              <div>
                <p className='text-darkText text-[22px] md:text-[20px] text-center font-semibold mb-3'>{item.title}</p>
                <p className='text-textColor text-center text-[14px]'>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChoose